<template>
  <div class="page">
    <Header></Header>
    <slot></slot>
    <Footer></Footer>
    <FloatIcon></FloatIcon>
  </div>
</template>
<script setup lang="ts">
const siteStore = useSiteStore()
const { ym_tit, ym_key, ym_des } = await siteStore.setSiteInfo()
useSeoMeta({
  title: ym_tit,
  description: ym_des,
  keywords: ym_key
})
</script>
<style lang="scss" scoped>
.page {
  width: 1600px;
  margin: 0 auto;
  background-color: #fff;
}

/* 媒体查询：当屏幕宽度小于768px时 */
@media screen and (max-width: 768px) {
  .page {
    width: 100vw;
  }
}
</style>
